import React from 'react';
var REGION_STYLES = 'pt-2 pr-10 pb-4 pl-10';
export var Region = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: REGION_STYLES }, children));
};
Region.displayName = 'Content.Region';
